import { SwiperSlide } from "swiper/react";
import clsx from "clsx";
import CompressedImage from "@/components/UI/CompressedImage/CompressedImage";
import PlaceholderImage from "@/app/assets/images/img/placeholder.png";
import Skeleton from "@/components/UI/Skeleton/Skeleton";
import styles from "@/components/UI/Skeleton/SearchSkeleton.module.scss";

export const SearchProductSkeleton = () => {
	return Array.from({ length: 3 }, (_, index) => (
		<article
			key={index}
			className={clsx([styles.product, styles.skeletonTemplate])}
		>
			<CompressedImage
				src={PlaceholderImage.src}
				altText={"Product Loading"}
				height={80}
				width={80}
				containerClass={styles.imageContainer}
				withNextImage={false}
			/>
			<div className={styles.skeletonDetails}>
				{Array.from({ length: 3 }, (_, index) => (
					<Skeleton key={index} className={styles.skeleton} />
				))}
			</div>
		</article>
	));
};

export const SearchSuggestionSkeleton = () => {
	return Array.from({ length: 3 }, (_, index) => (
		<Skeleton
			key={index}
			className={clsx([styles.skeleton, styles.suggestion])}
		/>
	));
};
